import React, { Component, Fragment } from 'react';
import InputPhoneNr from 'components/components/common/forms/InputPhoneNr';
import axios from 'components/AppRequest';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import TransHelper from 'components/common/translations/TransHelper';

class ChangePhoneForm extends Component {
  constructor(props) {
    super(props);
    this.inputPhoneRef = React.createRef();
  }

  state = {
    errors: {},
    isLoading: false,
  }

  trans = (key,pref  = "content.form") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  submitForm = (e) => {
    e.preventDefault();
    var phoneError = this.inputPhoneRef.current.validateForm();
    if (phoneError === null) {
      //reset errors
      this.setState({
        errors: {},
        isLoading: true,
      });
      this.sendRequest();
    } else {
      this.setState({ errors: { phone: phoneError } });
    }
  }

  sendRequest = () => {
    const { phoneCountry, phone } = this.props;
    var wholePhone = phoneCountry.label + phone;
    axios.post('/pwa/customer/check-phone-number', { phone: wholePhone })
      .then(response => {
        this.setState({ isLoading: false });
        this.props.toggleView();
      })
      .catch(err => {
        console.log("err", err.response)
        this.setState({
          errors: err.response.data.errors,
          isLoading: false
        });
      });
  }

  render() {
    const { errors, isLoading } = this.state;
    const { phoneCountry, phone } = this.props;
    return (
      <form onSubmit={this.submitForm}>
        <fieldset>
          <legend className="visuallyhidden">Phone Number Form</legend>
          <ul className="list-fields list-none mb-40">
            <li className="list-fields__item">
              <InputPhoneNr
                ref={this.inputPhoneRef}
                changePhoneCountry={this.props.changePhoneCountry}
                changePhoneNumber={this.props.changePhoneNumber}
                errorPhone={errors.phone}
                phoneNumber={phone}
                phoneCountry={phoneCountry}
                className="list-fields__phone-nr"
                locale={this.props.locale}
              />
            </li>
          </ul>
          <p className="text-center text-small mb-35">
            {this.trans('changePhoneDescriptionFirst')}
            <br />{this.trans('changePhoneDescriptionSecond')}
          </p>

          {isLoading
            ?
            <LoadingSpinner className="button button--expand" />
            :
            <button className="button button--expand">{this.trans('save','content.common')}</button>
          }
        </fieldset>
      </form>
    );
  }
}

export default ChangePhoneForm;
